import { createAction, props } from '@ngrx/store';

export const openModal = createAction('[Modal] Open Modal');

export const closeModal = createAction('[Modal] Close Modal');
